import { useQuery } from '@tanstack/react-query'
import { checkAuth } from '../../../../apis/auth'
import { queryKeys } from '../../../../shared'

type UseAuthCheckQueryOptions = {
  enabled?: boolean
  refetchInterval?: number | false
  refetchIntervalInBackground?: boolean
}

/**
 * 認証チェック Query hook
 *
 * 初回のみ認証状態を確認する（staleTime: Infinity）。
 * useRedirectToLogin と useCheckAuth で共有される。
 */
export const useAuthCheckQuery = (options?: UseAuthCheckQueryOptions) => {
  return useQuery({
    queryKey: queryKeys.auth.check(),
    queryFn: checkAuth,
    retry: false,
    staleTime: Infinity, // 初回のみ取得
    ...options,
  })
}
